export default __webpack_public_path__ + "static/reporting-weekly-a13604c6560fb6d3c791f20209a4e266.png";